import { StackablesDto } from "app/ApiClient";
import { LoadingState } from "types";

export type StackablesState = {
  loading: LoadingState;
  stackables: StackablesDto | null;
};
export const initialStackablesState: StackablesState = {
  loading: LoadingState.idle,
  stackables: null,
};
